import { COffcanvas } from './COffcanvas.js';
import { COffcanvasBody } from './COffcanvasBody.js';
import { COffcanvasHeader } from './COffcanvasHeader.js';
import { COffcanvasTitle } from './COffcanvasTitle.js';

const COffcanvasPlugin = {
    install: (app) => {
        app.component(COffcanvas.name, COffcanvas);
        app.component(COffcanvasBody.name, COffcanvasBody);
        app.component(COffcanvasHeader.name, COffcanvasHeader);
        app.component(COffcanvasTitle.name, COffcanvasTitle);
    },
};

export { COffcanvas, COffcanvasBody, COffcanvasHeader, COffcanvasPlugin, COffcanvasTitle };
//# sourceMappingURL=index.js.map
